import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import FormTable from "../../../common/components/functional/formTable/FormTable";
import useLanguageSkills from "../../../hooks/useLanguageSkills";
import { Language } from "../../talents/talentAPI";
import { ModalState } from "../types/types";
import Languages from "./Languages";

const DRAG_HANDLE_SELECTOR = "drag-handle-languages";

const LanguagesTable = () => {
  const [modalState, setModalState] = useState<ModalState>({
    show: false,
    id: "",
  });

  const { t } = useTranslation("languageSkill");
  const { watch, getValues, setValue } = useFormContext();

  const { getLanguageSkillsNameByCode } = useLanguageSkills();

  const languageHeaders = [{ text: t("language") }, { text: t("level") }];
  const languages: Language[] = watch("languages");
  const tableData = languages
    .map((language) => ({
      values: {
        languageCode: getLanguageSkillsNameByCode(language.languageCode),
        skillLevel: t(`${language.skillLevel}`),
      },
      id: language.id,
      editable: true,
      deletable: true,
    }))
    .sort((a, b) => a.values.languageCode.localeCompare(b.values.languageCode));

  const onOpen = (id?: string) => {
    setModalState({ show: true, id });
  };
  const onClose = () => setModalState({ show: false, id: "" });
  const handleDelete = (id: string) => {
    const languages: Language[] = getValues("languages");
    const updatedLanguages = languages.filter((language) => language.id !== id);
    setValue("languages", updatedLanguages, { shouldDirty: true });
  };

  const addButtonLabel = t("add");

  return (
    <>
      <Grid
        container
        item
        xs={3}
        justifyContent="flex-end"
        alignItems="flex-start"
      >
        <Typography color="textSecondary">{t("skill")}</Typography>
      </Grid>
      <Box paddingLeft="1rem">
        <FormTable
          data={tableData}
          headers={languageHeaders}
          handleOpenEditModal={(_, id) => onOpen(id)}
          addButtonLabel={addButtonLabel}
          handleDelete={(id) => handleDelete(id)}
          valueMaxLines={3}
        />
      </Box>
      <DialogComponent
        open={modalState.show}
        onClose={onClose}
        dragHandleSelector={DRAG_HANDLE_SELECTOR}
      >
        <Languages languageId={modalState.id} onClose={onClose} />
      </DialogComponent>
    </>
  );
};

export default LanguagesTable;
